define(['app'], function (app) {
  return app.Marionette.ItemView.extend({
    template: false,

    // Options for this function which can be set in twig
    options: {
      url: null,
      title: null,
      excerpt: null,
      w: 800,
      h: 600
    },

    // Social button popup window centered
    customPopupCenter: function (url, title, excerpt, w, h) {
      var dualScreenLeft = window.screenLeft !== undefined
        ? window.screenLeft
        : window.screen.left
      var dualScreenTop = window.screenTop !== undefined
        ? window.screenTop
        : window.screen.top
      var width = window.innerWidth
        ? window.innerWidth
        : document.documentElement.clientWidth
          ? document.documentElement.clientWidth
          : window.screen.width
      var height = window.innerHeight
        ? window.innerHeight
        : document.documentElement.clientHeight
          ? document.documentElement.clientHeight
          : window.screen.height
      var left = width / 2 - w / 2 + dualScreenLeft
      var top = height / 2 - h / 2 + dualScreenTop
      var newWindow = window.open(
        url,
        title,
        'scrollbars=yes, width=' +
            w +
            ', height=' +
            h +
            ', top=' +
            top +
            ', left=' +
            left
      )

      // Puts focus on the newWindow
      if (window.focus) {
        newWindow.focus()
      }
    },

    // Initialize the helper with parsing options
    initialize: function () {
      this.render()
    },

    // Call on the click function of the share button
    onRender: function () {
      var self = this
      var href = this.options.url ? this.options.url : this.$el.attr('href')
      this.options.url = href

      this.$el.on('click', function (e) {
        e.preventDefault()
        self.customPopupCenter(
          self.options.url,
          self.options.title,
          self.options.excerpt,
          self.options.w,
          self.options.h
        )
      })
    }
  })
})
